<template>
  <div class="stock-page">
    <div :class="['block', {'block-pop': popped}]">
      <div class="hd" v-show="!popped">
        <div v-for="item in tabData" :class="['tab', {'current': tabKey==item}]" v-text="item" @click="tabSwitch(item)"></div>
      </div>
      <div :class="['item-block', {'top0': popped}]" v-show="tabKey=='物料占比'">
        <div class="itm"><span v-text="shelfNo+'#货架'" v-if="viewKey=='货位'"></span></div>
        <div class="itm">
          <span class="swbtn" v-for="item in viewTypes" :class="[{'current': viewKey==item}]" v-text="item" @click="viewSwitch(item)"></span>
        </div>
      </div>
      <div class="list-box" v-if="tabKey=='物料占比'">
        <div class="table">
          <table>
            <thead>
              <tr>
                <th :width="popped?180:120">编号</th>
                <th>物料</th>
                <template v-if="viewKey=='库区'">
                  <th :width="popped?150:90">数量</th>
                </template>
                <template v-else>
                  <template v-if="viewKey=='巷道'">
                    <th :width="popped?150:90">巷道1</th>
                    <th :width="popped?150:90">巷道2</th>
                    <th :width="popped?150:90">巷道3</th>
                    <th :width="popped?150:90">巷道4</th>
                  </template>
                  <template v-else>
                    <th :width="popped?150:90">1区</th>
                    <th :width="popped?150:90">2区</th>
                    <th :width="popped?150:90">3区</th>
                    <th :width="popped?150:90">标准差</th>
                  </template>
                </template>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in wlzbList">
                <td>
                  <span class="tdtxt" v-text="item.MaterialCode"></span>
                  <div class="full-box">
                    <span class="txt" v-text="item.MaterialCode"></span>
                  </div>
                </td>
                <td>
                  <span class="tdtxt" v-text="item.MaterialName"></span>
                  <div class="full-box">
                    <span class="txt" v-text="item.MaterialName"></span>
                  </div>
                </td>

                <template v-if="viewKey=='库区'">
                  <td><span v-text="item.Count"></span></td>
                  <!-- <td><span v-text="item.DifferenceValue"></span></td> -->
                </template>
                <template v-if="viewKey=='巷道'">
                  <td v-for="item1 in item.TunnelRows" v-if="item1.TunnelNo==1"><span v-text="item1.Count"></span></td>
                  <td v-for="item1 in item.TunnelRows" v-if="item1.TunnelNo==2"><span v-text="item1.Count"></span></td>
                  <td v-for="item1 in item.TunnelRows" v-if="item1.TunnelNo==3"><span v-text="item1.Count"></span></td>
                  <!-- <td><span v-text="item.TunnelAverageCount"></span></td> -->
                  <td v-for="item1 in item.TunnelRows" v-if="item1.TunnelNo==4"><span v-text="item1.Count"></span></td>
                </template>
                <template v-if="viewKey=='货位'">
                  <td v-for="item2 in item.RegionRows" v-if="item2.RegionNo==1"><span v-text="item2.Count"></span></td>
                  <td v-for="item2 in item.RegionRows" v-if="item2.RegionNo==2"><span v-text="item2.Count"></span></td>
                  <td v-for="item2 in item.RegionRows" v-if="item2.RegionNo==3"><span v-text="item2.Count"></span></td>
                  <td><span v-text="item.RegionAverageCount"></span></td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="page-container">
          <v-pagination :total="totalCount" size="mini" :display="pageSize" :current-page='pageIndex' @pagechange="pageChange"></v-pagination>
        </div>
      </div>
      <div class="chart-box" v-if="tabKey=='库龄分布'">
        <div class="checkbox">
          <input type="checkbox" :checked="emptyTrayShowed" @click="emptyTrayClick()">空托盘
        </div>
        <v-chart :options="options_klfb" />
      </div>
      <div class="chart-box" v-if="tabKey=='货位状态'">
        <v-chart :options="options_hwzt" />
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts/lib/echarts'
import pagination from '@/components/widgets/Pagination'
export default{
  components: {
    'v-pagination': pagination,
  },
  props: ['theme'],
  inject: ["reload"],  //注入reload方法
  data() {
    let tabData = [
      '物料占比', '库龄分布', '货位状态'
    ];
    let viewTypes = [
      '库区', '巷道', '货位'
    ];

    return {
      tabData: tabData,
      tabKey: tabData[0],
      viewTypes: viewTypes,
      viewKey: viewTypes[0],
      shelfNo: 1,
      emptyTrayShowed: true,
      popped: false,
      wlzbListAll: {},
      wlzbList: [],
      klfbList: [],
      options_klfb: {},
      hwztList: [],
      options_hwzt: {},
      totalCount: 0,
      pageIndex: 1,
      pageSize: 4,
    }
  },
  watch: {
    popped(val) {
      if(!val) {
        this.pageSize = 4;
      } else {
        this.pageSize = 4*4+1;
      }
      this.pageChange(1);
    },
  },
  mounted() {
    let self = this;
    //定义全局方法
    window.gbfc_viewSwitch = this.viewSwitch;
    window.gbfc_resetData = this.resetData;
    window.gbfc_popupWindow = this.popupWindow;
    window.gbfc_getData = this.getData;
    //window.gbfc_reloadPage = this.reload;
    //初始化
    this.$initPage(this);
    if(this.$route.query.popped == 1) {
      this.popped = true;
    }
  },
  methods: {
    getData() {
      /*let lists = [];
      this.$handleRequest(window.ApiHost1+'/api/DataStatistical/Mat_Info', {
        "KeyWord": "",
        "ShelfNo": this.shelfNo,
        "WareHouseCode": window.PYKWareHouseCode,
      }, 'post', function(res) {  //success
        lists = res.retData;
      });
      let timer = setInterval(function() {
        if(lists > 0) {
          clearInterval(timer);
          return JSON.stringify(lists);
        }
      }, 10000);*/
      return JSON.stringify(this.wlzbListAll);
    },
    tabSwitch(item) {
      this.tabKey = item;
      this.resetData();
    },
    viewSwitch(item, shelfNo) {
      if(item && item == '货架') {
        item = '巷道';
      }
      this.shelfNo = shelfNo ? shelfNo : 1;
      this.viewKey = item;
      this.resetData();
    },
    emptyTrayClick() {
      this.emptyTrayShowed = !this.emptyTrayShowed;
      this.getKlfbList();
    },
    popupWindow(val) {
      this.popped = val;
    },
    resetData() {
      console.log(this.tabKey+'-'+this.viewKey);
      if(this.tabKey == '物料占比') {
        this.getWlzbList();
      } else if(this.tabKey == '库龄分布') {
        this.getKlfbList();
      } else if(this.tabKey == '货位状态') {
        this.getHwztList();
      }
    },
    getWlzbList() {
      let self = this;
      let url = '/api/DataStatistical/Mat_Info';
      //url = '/static/data/Mat_Info.json';
      this.$handleRequest(window.ApiHost1+url, {
          "KeyWord": "",
          "ShelfNo":"00" + this.shelfNo,
          "WareHouseCode": window.PYKWareHouseCode,
        }, 'post', function(res) {  //success



          self.wlzbListAll = res.retData;
          let lists = res.retData.Rows;
          if(self.viewKey == '货位') {
            lists = res.retData.RegionRows;
          }
          self.wlzbList = self.$dataPage(lists, self.pageIndex, self.pageSize);
          self.totalCount = lists.length;
        }, function(res) {  //fail
      });
    },
    getKlfbList() {
      let self = this;
      let url = '/api/DataStatistical/Inv_Age_Count';
      this.$handleRequest(window.ApiHost1+url, {
          "ShowEmptyTray": this.emptyTrayShowed,
          "WareHouseCode": window.PYKWareHouseCode,
        }, 'post', function(res) {  //success

          self.klfbList = res.retData.Rows;
          self.setOptionsKlfb();
        }, function(res) {  //fail
      });
    },
    setOptionsKlfb() {
      let colors = this.$charts.colors.style_1;
      let chartsConf = this.$charts[window.CurrentTheme];
      let sdata = [];
      let legendData = [];
      this.klfbList.forEach( function(d, di) {
        legendData.push(d.Name);
        let color1 = colors[di][0];
        let color2 = colors[di][1];
        let tmp = {
          value: d.Count,
          name: d.Name,
          label: {
            normal: {
                rich: {
                  hr: {
                    borderColor: color2
                  },
                  per: {
                    color: color2
                  }
                }
            }
          },
          itemStyle:{
            normal:{
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {offset: 0, color: color1}, {offset: 1, color: color2}
              ])
            }
          }
        };
        sdata.push(tmp);
      });

      this.options_klfb = {
        legend: {
          right: 100,
          bottom: 0,
          textStyle: {
            color: chartsConf.legend.color,
            fontSize: 22
          },
          data: legendData
        },
        series: [
          {
            type:'pie',
            radius: ['38%', '55%'],
            avoidLabelOverlap: true,
            labelLine: {
              //length: 30,
              length2: 30
            },
            label: {
              normal: {
                  formatter: '{per|{d}%}',
                  //formatter: '{per|{d}%} \n{hr|}\n {b|{b}}',
                  //backgroundColor: '#061445',
                  //padding: 15,
                  //borderColor: '#5165b7',
                  //borderWidth: 1,
                  rich: {
                    hr: {
                      //borderColor: '#fff',
                      width: '100%',
                      borderWidth: 0.5,
                      height: 0,
                    },
                    b: {
                      align: 'center',
                      fontSize: 24,
                      color: chartsConf.series.color,
                      padding: [0, 0, 5, 0]
                    },
                    per: {
                      align: 'center',
                      fontSize: 24,
                      padding: [5, 0, 0, 0]
                    }
                  }
              }
            },
            data: sdata
          }
        ]
      };
    },
    getHwztList() {
      let self = this;
      let url = '/api/DataStatistical/ShelfGrid_StateRto';
      this.$handleRequest(window.ApiHost1+url, {
        "WareHouseCode": window.PYKWareHouseCode,
      }, 'post', function(res) {  //success
        self.hwztList = res.retData.Rows;
        self.setOptionsHwbj();
      }, function(res) {  //fail
        console.log('--fail--', res)
      });
    },
    setOptionsHwbj() {
      let colors = this.$charts.colors.style_1;
      let chartsConf = this.$charts[window.CurrentTheme];
      let sdata = [];
      let legendData = [];      
      this.hwztList.forEach( function(d, di) {
        legendData.push(d.ShelfGridStateName);
        let color1 = colors[di][0];
        let color2 = colors[di][1];
        let tmp = {
          value: d.Count,
          name: d.ShelfGridStateName,
          label: {
            normal: {
                rich: {
                  hr: {
                    borderColor: color2
                  },
                  per: {
                    color: color2
                  }
                }
            }
          },
          itemStyle:{
            normal:{
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {offset: 0, color: color1}, {offset: 1, color: color2}
              ])
            }
          }
        };
        sdata.push(tmp);
      });

      this.options_hwzt = {
        legend: {
          right: 100,
          textStyle: {
            color: chartsConf.legend.color,
            fontSize: 22
          },
          data: legendData
        },
        series: [
          {
            type:'pie',
            radius: ['38%', '55%'],
            center: ['50%', '65%'],
            avoidLabelOverlap: true,
            labelLine: {
              //length: 30,
              length2: 30
            },
            label: {
              normal: {
                  formatter: '{per|{d}%}{per|({c})}',
                  //formatter: '{per|{d}%} \n{hr|}\n {b|{b}}',
                  //backgroundColor: '#061445',
                  //padding: 15,
                  //borderColor: '#5165b7',
                  //borderWidth: 1,
                  rich: {
                    hr: {
                      //borderColor: '#fff',
                      width: '100%',
                      borderWidth: 0.5,
                      height: 0,
                    },
                    b: {
                      align: 'center',
                      fontSize: 24,
                      color: chartsConf.series.color,
                      padding: [0, 0, 5, 0]
                    },
                    per: {
                      align: 'center',
                      fontSize: 24,
                      padding: [5, 0, 0, 0]
                    }
                  }
              }
            },
            data: sdata
          }
        ]
      };
    },

    pageChange(pageIndex) {
      console.log('pageIndex', pageIndex);
      this.pageIndex = pageIndex;
      this.getWlzbList();
    },
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/xiayan/stock/StockChart2.vue